import * as React from "react";
import { useSelector } from "react-redux";
import { symbols } from "../../../../constant/symbols";
import Stocks from "./stock";
import _ from "underscore";
const StockValue = (props) => {
    const streamSelected = useSelector((state) => state.header.stream[0], _.isEqual);
    const stream = React.useMemo(() => streamSelected, [streamSelected]);
    const [NSEObj, setNSEObj] = React.useState();
    const [BSEObj, setBSEObj] = React.useState();
    React.useEffect(() => {
        switch (stream.symbol) {
            case symbols[1].symbol:
                setNSEObj(stream);
                break;
            case symbols[0].symbol:
                setBSEObj(stream);
                break;
        }
    }, [stream]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "displayFlex stockValues" }, (props === null || props === void 0 ? void 0 : props.userSelected) ? (props.globleData.map((pin, i) => {
            return (React.createElement(Stocks, { key: i, label: pin.displayName + " :", curPrice: pin.latestTradingPrice, changePrice: pin.change, changePercentage: pin.changePercentage, classList: "edel-icon-caret-up", parentClass: "common-stock" }));
        })) : (React.createElement(React.Fragment, null,
            React.createElement(Stocks, { label: symbols[1].EdelCode + " : ", curPrice: NSEObj === null || NSEObj === void 0 ? void 0 : NSEObj.curPrice, changePrice: NSEObj === null || NSEObj === void 0 ? void 0 : NSEObj.changePrice, changePercentage: NSEObj === null || NSEObj === void 0 ? void 0 : NSEObj.changePercentage }),
            React.createElement(Stocks, { label: symbols[0].EdelCode + " : ", curPrice: BSEObj === null || BSEObj === void 0 ? void 0 : BSEObj.curPrice, changePrice: BSEObj === null || BSEObj === void 0 ? void 0 : BSEObj.changePrice, changePercentage: BSEObj === null || BSEObj === void 0 ? void 0 : BSEObj.changePercentage }))))));
};
export default StockValue;
